// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wp_vue_editor[data-v-0091274d]{width:100%;min-height:100px}.wp_vue_editor_wrapper[data-v-0091274d]{position:relative}.wp_vue_editor_wrapper .popover-wrapper[data-v-0091274d]{z-index:2;position:absolute;top:0;right:0}.wp_vue_editor_wrapper .popover-wrapper-plaintext[data-v-0091274d]{left:auto;right:0;top:-32px}.wp_vue_editor_wrapper .wp-editor-tabs[data-v-0091274d]{float:left}", ""]);
// Exports
module.exports = exports;
